import { AppError, ErrorCode, ErrorSeverity } from '../types';

export function fromFirestoreError(err: any): AppError {
  const code = String(err?.code ?? '');
  const msg = String(err?.message ?? '');
  
  // Handle transient errors that should be silent and auto-retried
  if (['unavailable', 'deadline-exceeded', 'resource-exhausted', 'aborted', 'cancelled'].includes(code)) {
    return new AppError({ 
      code: ErrorCode.TRANSIENT_BACKEND_UNAVAILABLE, 
      domain: 'firestore', 
      cause: err,
      severity: ErrorSeverity.Warn,
      message: 'Firestore is temporarily unavailable. Retrying…'
    });
  }
  
  // Handle specific Firestore error codes
  if (code === 'permission-denied') return new AppError({ code: ErrorCode.DB_PERMISSION_DENIED, domain: 'firestore', cause: err });
  if (code === 'not-found') return new AppError({ code: ErrorCode.DB_NOT_FOUND, domain: 'firestore', cause: err });
  if (code === 'already-exists') return new AppError({ code: ErrorCode.DB_ALREADY_EXISTS, domain: 'firestore', cause: err });
  if (code === 'failed-precondition') return new AppError({ code: ErrorCode.DB_UNAVAILABLE, domain: 'firestore', cause: err });
  if (code === 'invalid-argument') return new AppError({ code: ErrorCode.VALIDATION_FAILED, domain: 'firestore', cause: err });
  
  // Handle index-related errors
  if (msg.includes('requires an index') || msg.includes('index')) {
    return new AppError({ code: ErrorCode.DB_INDEX_REQUIRED, domain: 'firestore', cause: err });
  }
  
  // Handle network-related errors including QUIC protocol errors
  if (msg.includes('network') || msg.includes('timeout') || msg.includes('connection') || 
      msg.includes('QUIC') || msg.includes('quic') || msg.includes('protocol') ||
      code === 'unavailable' || code === 'deadline-exceeded') {
    return new AppError({ 
      code: ErrorCode.TRANSIENT_BACKEND_UNAVAILABLE, 
      domain: 'firestore', 
      cause: err,
      severity: ErrorSeverity.Warn,
      message: 'Network error. Retrying…'
    });
  }
  
  // For truly unknown errors, return UNKNOWN but with better context
  return new AppError({ 
    code: ErrorCode.UNKNOWN, 
    domain: 'firestore', 
    cause: err,
    severity: ErrorSeverity.Warn,
    message: `Firestore error: ${msg || code || 'Unknown error'}`
  });
}
